import styled from "styled-components";
import React from "react";
import breakpoints from "Helpers/BreakpointHelper";

import media from "styled-media-query";

export const Caption = ({ byline }) => {
	return (
		<CaptionStyle byline={byline}>
			<span>{byline}</span>
		</CaptionStyle>
	);
};

export const CaptionStyle = styled.div`
	display: ${(props) => (props.byline ? "flex" : "none")};
	background-color: ${({theme}) => theme.colors.lightgrey};
	padding: 0.5rem 1rem 0.5rem 2rem;
	border-bottom-left-radius: ${({theme}) => theme.border.radius};
	border-bottom-right-radius: ${({theme}) => theme.border.radius};
	color: black;
	${media.lessThan(breakpoints.mobile)`
    padding: 0.5rem 1rem;
    `}
`;
